// eslint-disable-next-line

export default {
  namespaced: true,
  state: {
    /* = data */
    currentTab: 'GrassType',
    loading: {
      activity: true,
      facilityType: false,
      grassType: false,
      manager: false,
    },
  },

  getters: {
    /* = Computed properties, perfects to filter data an execute some calculation */
  },

  mutations: {
    /* Mutations are responsible to change the state */
    setCurrentTab(state, tab) {
      state.currentTab = tab;
    },
    setLoading(state, loading) {
      state.loading = {
        ...state.loading,
        ...loading,
      };
    },
  },

  actions: {
    /* = Methods */
  },
};
